export const enum StatusEnums {
  Active = 1,
  Inactive = 2,
  Failed = 3,
  Paid = 4,
  UnPaid = 5,
  WaitingPaymentDate = 6,
}
